import React from 'react'
import '../Results.css'
import '../Results/AdminDrawer.css'
import Drawer from '../Results/Drawer'

const TSDrawer = ({
  isSearchOpen,
  closeSearch,
  searchActivated,
  tableSearchMessage,
  handleTableSearchInput,
  handleTableSearch,
  tableSearchResults,
  handleTSPopup
}) => {
  return (
    <Drawer
      className="Table-Search-drawer"
      isOpen={isSearchOpen}
      onClose={closeSearch}
      title="Table Search"
      icon="archive">
      <div className="table-search-container">
        <div
          className="table-search-input"
          style={{
            pointerEvents: searchActivated ? 'auto' : 'none',
            opacity: !searchActivated ? 0.2 : 1
          }}>
          <one-ux-field label="Search" compact>
            <one-ux-textarea
              line-count="4"
              width="max"
              placeholder="Search for a table here"
              value={tableSearchMessage}
              onChange={handleTableSearchInput}></one-ux-textarea>
          </one-ux-field>

          <one-ux-button label="Search" onClick={handleTableSearch}>
            <one-ux-icon slot="start" icon="search"></one-ux-icon>
          </one-ux-button>
        </div>
        <one-ux-scroll className="table-scroll">
          <div class="table-search-results">
            {tableSearchResults.map((result, index) => (
              <div
                key={index}
                className="table-search-card"
                onClick={() => handleTSPopup(result.title, result.context)}>
                <div class="one-ux-typography--heading-300">{result.title}</div>
                <div class="one-ux-typography--body-400">{result.context.slice(0, 200) + '...'}</div>
              </div>
            ))}
          </div>
        </one-ux-scroll>
      </div>
    </Drawer>
  )
}
export default TSDrawer
